import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import PurposeServices from "./Purpose.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getPurpose = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PURPOSE,
      payload: true,
    });
    const resp = await PurposeServices.getPurpose(filters);
    dispatch({
      type: actions.GET_PURPOSE,
      payload: {
        purposes: resp.data.data,
        purposesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.PURPOSE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PURPOSE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PURPOSE,
      payload: false,
    });
  }
};

export const getPurposeById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PURPOSE,
      payload: true,
    });
    const resp = await PurposeServices.getPurposeByID(id);
    dispatch({
      type: actions.GET_PURPOSE,
      payload: {
        purposes: resp.data,
      },
    });
    dispatch({
      type: actions.PURPOSE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PURPOSE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PURPOSE,
      payload: false,
    });
  }
};

export const savePurpose = (data, setShowModal, desc, setIsSelect) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_PURPOSE,
        payload: true,
      });
      const resp = await PurposeServices.savePurpose(data);
      const { purposes, purposesLength } = getState().purpose;
      let _data =  resp.data;
      const _purposes = [...purposes, _data];
      dispatch({
        type: actions.GET_PURPOSE,
        payload: {
          purposes: _purposes,
          purposesLength: purposesLength + 1,
        },
      });
      if(desc){
        setIsSelect(true);
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_PURPOSE,
        payload: false,
      });
    }
  };

export const editPurpose =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_PURPOSE,
        payload: true,
      });
      const resp = await PurposeServices.editPurpose(id, data);
      const { purposes, purposesLength } = getState().purpose;
      purposes[index] = resp.data;
      dispatch({
        type: actions.GET_PURPOSE,
        payload: {
          purposes: purposes,
          purposesLength: purposesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PURPOSE,
        payload: false,
      });
    }
  };

export const deletePurpose = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_PURPOSE,
      payload: true,
    });
    await PurposeServices.deletePurpose(id);
    const { purposes, purposesLength } = getState().purpose;
    purposes.splice(index, 1);
    dispatch({
      type: actions.GET_PURPOSE,
      payload: {
        purposes: purposes,
        purposesLength: purposesLength - 1,
      },
    });
    dispatch({
      type: actions.PURPOSE_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.PURPOSE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PURPOSE,
      payload: false,
    });
  }
};
